<template>
  <md-table-row>
    <md-table-cell md-label="Insumo">
      {{ supply.supplyName }}
    </md-table-cell>
    <md-table-cell md-label="Proveedor">
      <md-field v-if="hSupplies.length">
        <label>Proveedor</label>
        <md-select
          v-model="hSupply"
          :disabled="!(hSupplies && hSupplies.length)"
        >
          <md-option
            v-for="hSupply in hSupplies"
            :key="hSupply.id"
            :value="hSupply.id"
          >
            {{ hSupply.provider.name }} <br />
            {{ hSupply.price | money }}
          </md-option>
        </md-select>
      </md-field>

      <p class="text-danger" v-else>
        <strong>No hay proveedores disponibles en el campamento.</strong>
      </p>
    </md-table-cell>

    <md-table-cell md-label="Precio de proveedor">
      {{ supply.currentPrice | money }}
    </md-table-cell>

    <md-table-cell md-label="Precio negociado">
      <md-field>
        <md-input v-model="supply.price"></md-input>
      </md-field>
    </md-table-cell>
  </md-table-row>
</template>

<script>

import purchaseService from '@/services/purchase'

export default {

  name: 'QuotationSupplyRow',

  props: {
  	supply: Object,
    campId: {
      type: Number,
      required: true
    }
  },

  mounted() {
  	const supply = this.supply
  	purchaseService.fetchSupplyHighwaySupplies(supply.supplyId, 
      {camp: this.campId})
    	.then(hsupplies => {
    		const hSupplies = hsupplies
    		this.hSupplies = hSupplies
    	})
  },

  watch: {
  	hSupply(id) {
  		const hSupply = this.hSupplies
  			.filter(hS => hS.id == id)[0]
      this.supply.providerId = hSupply.provider.id
  		this.supply.currentPrice = hSupply.price
  		this.supply.price = hSupply.price
  	}
  },

  data () {
    return {
    	hSupplies: [],
    	hSupply: null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Purchases/Quotations/QuotationSupplyRow.vue